import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogContent, Tooltip} from '@mui/material';
import axios from 'axios';
import CaseStatus from "../../enums/CaseStatus";
import {useLocation} from 'react-router-dom';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import OrderDecisionEnum from "../../enums/orderDecisionEnum";

const MakeDecision = ({
                          caseFiles,
                          disabledBecauseOfdeclinedFiles,
                          onStatusChange,
                          disabled,
                          onDecisionMake,
                          onConditionAct,
                          conditionButtonActButtonExists,
                          hasConditionalDeadline,
                          disableCaseFinishButtonForExplosion,
                          isObjectRegistery,
                          isObjectMovedToRegistery,
                          users
                      }) => {
    const [open, setOpen] = useState(false);
    const [disabledButton, setDisabledButton] = useState(true);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const location = useLocation();
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const documentsWithPermitDate = caseFiles.filter(doc => doc.termOfPermitDate !== null);
    const sortedDocuments = documentsWithPermitDate.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const newestDocumentWithPermitDate = sortedDocuments[0];
    const approveDocExists = caseFiles.filter(doc => doc.orderDecision === OrderDecisionEnum.Approve.id)
    const denyDocExists = caseFiles.filter(doc => doc.orderDecision === OrderDecisionEnum.Decline.id)
    const [signedDocExists, setSignedDocExists] = useState(false);
    const [isDisabledBecauseNotMovedToRegistery, setIsDisabledBecauseNotMovedToRegistery] = useState(false);

    useEffect(() => {
        if (!isObjectRegistery) {
            setIsDisabledBecauseNotMovedToRegistery(false)
        } else {
            setIsDisabledBecauseNotMovedToRegistery(!isObjectMovedToRegistery)
        }
    }, [isObjectRegistery, isObjectMovedToRegistery]);


    useEffect(() => {

        const signedCaseFiles = caseFiles.filter(doc => doc.isDocumentSigned);
        if (signedCaseFiles.length > 0) {
            setSignedDocExists(true);
        }

    }, [caseFiles]);


    const updateTermOfPermitDate = async () => {
        const caseId = getCaseIdFromUrl();

        const permitData = {
            caseId: parseInt(caseId),
            termOfPermitDate: newestDocumentWithPermitDate.termOfPermitDate,

        };
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateTermOfPermitDateAndConditionDeadline`, permitData);
    };

    useEffect(() => {
        if (conditionButtonActButtonExists) {
            setDisabledButton(false)
        } else if (!disabled) {
            setDisabledButton(false)
        } else {
            setDisabledButton(true)
        }
    }, [conditionButtonActButtonExists, disabled]);

    const fetchDateTime = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Datetime/GetDatetimeNow`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch current date and time.');
        }
    };

    const formatDateTimeToISO = (dateTime) => {
        return new Date(dateTime).toISOString();
    };


    const updateSharedFiles = async () => {

        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");

        const tempSharedFiles = caseFiles.filter(file => file.sharedTemp === true || file.approvalDocument === true || file.decline === CaseFileDeclined.ConditionalFileAct || file.parentId !== null);


        const headAgencyFiles = tempSharedFiles.filter(file => (file.activeUserId === headOfAgency.id) || (file.parentId !== null));


        const updateFilePromises = headAgencyFiles.map(async (file) => {
            const updatedFileData = {
                ...file,
                shared: file.sharedTemp ? true : file.shared,
                approvalDocument: false,
                decline: file.decline === CaseFileDeclined.ConditionalFileAct ? CaseFileDeclined.ConditionalFileActSent : file.decline

            };
            try {
                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFileData);
            } catch (error) {
            }
        });

        try {
            await Promise.all(updateFilePromises);
        } catch (error) {
        }
    };


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleStatusSelect = (status) => {
        setSelectedStatus(status);
        setConfirmOpen(true);
    };

    const getCaseIdFromUrl = () => {
        const query = new URLSearchParams(location.search);
        return query.get('id');
    };

    const updateCaseStatus = async () => {
        const caseId = getCaseIdFromUrl();

        try {
            if (newestDocumentWithPermitDate) {
                await updateTermOfPermitDate()
            }
            const currentDateTime = await fetchDateTime();
            const formattedDateTime = formatDateTimeToISO(currentDateTime);

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatus`, {
                caseId: parseInt(caseId),
                caseStatus: selectedStatus,
                finished: true,
                finishDate: formattedDateTime
            });

            await updateSharedFiles();
            const data = response.data;
            if (data.success) {
                setAlertInfo({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
                onStatusChange();
                onDecisionMake();
            } else {
                setAlertInfo({show: true, message: data.errorMessage || 'Error updating status.', type: 'error'});
            }
        } catch (error) {
            setAlertInfo({show: true, message: 'Network error or server is unreachable.', type: 'error'});
        } finally {
            handleConfirmClose();
            handleClose();
        }
    };


    const closeAlert = () => {
        setAlertInfo({...alertInfo, show: false});
    };


    return (
        <div>
            <Tooltip
                title={disabledBecauseOfdeclinedFiles ? "ჯერ გაეცით პასუხი დახარვეზებულ დოკუმენტებს!" :
                    disabledButton ? "წარმოების დასრულებისთვის უნდა აიტვირთოს დადასტურების დოკუმენტები!" :
                        !signedDocExists ? "წარმოების დასრულებისთვის მოაწერეთ ხელი ბრძანებას!" :
                            disableCaseFinishButtonForExplosion ? "წარმოების დასრულებისთვის უნდა აიტვირთოს სანებართვო მოწმობა!" :
                                ""}>
                <button
                    disabled={disabledButton || disabledBecauseOfdeclinedFiles || disableCaseFinishButtonForExplosion || !signedDocExists}
                    className={"document-buttonn-green"} onClick={handleClickOpen}>
                    წარმოების დასრულება
                </button>
            </Tooltip>

            <Dialog style={{zIndex: 150}} open={open} onClose={handleClose}>
                <DialogContent>

                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Tooltip
                            title={isDisabledBecauseNotMovedToRegistery ? "წარმოების დასრულებისთვის ობიექტი უნდა გადაიტანოთ უწყებრივ რეესტრში!" : ""}>
                            <span>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    key={CaseStatus.Approved.id}
                                    onClick={() => handleStatusSelect(CaseStatus.Approved.id)}
                                    style={!conditionButtonActButtonExists && approveDocExists.length !== 0 && !isDisabledBecauseNotMovedToRegistery ? {
                                            width: 300,
                                            marginTop: 10,
                                            backgroundColor: "green"
                                        }
                                        : {
                                            width: 300,
                                            marginTop: 10,
                                            backgroundColor: "lightgrey",
                                            cursor: "not-allowed !important"
                                        }}
                                    disabled={conditionButtonActButtonExists || approveDocExists.length === 0 || isDisabledBecauseNotMovedToRegistery}

                                >
                                    დადებითი პასუხი
                                </Button>
                            </span>
                        </Tooltip>
                        <Button
                            variant="contained"
                            color="primary"
                            key={CaseStatus.FinishedDenied.id}
                            onClick={() => handleStatusSelect(CaseStatus.FinishedDenied.id)}
                            style={!conditionButtonActButtonExists && denyDocExists.length !== 0 ? {
                                    width: 300,
                                    marginTop: 10,
                                    backgroundColor: "red"
                                }
                                : {width: 300, marginTop: 10, backgroundColor: "lightgrey", cursor: "not-allowed"}}
                            disabled={conditionButtonActButtonExists || denyDocExists.length === 0}

                        >
                            უარი ნებარვაზე
                        </Button>
                    </div>
                    {hasConditionalDeadline && (
                        <Button disabled={!conditionButtonActButtonExists} style={conditionButtonActButtonExists ? {
                                width: 300,
                                marginTop: 10,
                                backgroundColor: "#d1ac28",
                                color: "white"
                            }
                            : {width: 300, marginTop: 10, backgroundColor: "lightgrey", cursor: "not-allowed"}}
                                onClick={onConditionAct}>
                            პირობით დასრულება
                        </Button>
                    )}



                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={confirmOpen}
                onRequestClose={handleConfirmClose}
                onConfirm={updateCaseStatus}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={closeAlert}
                />
            )}
        </div>
    );
};

export default MakeDecision;
